module.exports = __webpack_public_path__ + "media/images/arrows/down-18a9cc66ced41dc49aa6d2ff7c9a243e.svg";